export default __webpack_public_path__ + "static/media/nasa-logo.2268b0da.png";